import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import withBeelineStore from '../withBeelineStore';

const withServiceConnection = (Comp) => {
  const mapStateToProps = (state) => {
    if (!state.external) return {};
    return {
      serviceConnectionPopup: state.external.serviceConnectionPopup,
    };
  };

  const mapDispatchToProps = (dispatch) => {
    const actions = window.beeline.pages.sharingActions;

    if (!actions) return {};
    const {
      resetServicePopupResult,
      initServiceConnectionPopup,
      showServiceConnectionPopup,
      connectService,
    } = actions;

    return {
      ...bindActionCreators({
        connectService: (data) => connectService(data),
        resetServicePopupResult: () => resetServicePopupResult(),
      }, dispatch),

      initServiceConnection: (initUrl, { soc, socs, name, ignoreConflictSocs }) => {
        dispatch(resetServicePopupResult());
        dispatch(initServiceConnectionPopup({
          connectPopupUrl: initUrl,
          soc,
          servicesSocs: socs,
          ignoreConflictSocs,
        }));

        dispatch(showServiceConnectionPopup({
          serviceName: name,
          isAuthenticated: true,
          soc,
        }));
      },
    };
  };

  const WithServiceConnectionHOC = connect(mapStateToProps, mapDispatchToProps)(Comp);

  return withBeelineStore(WithServiceConnectionHOC);
};

export default withServiceConnection;
